import './playerArondTable.css';
import avatar from 'assets/avatar.png';
import joker from 'assets/joker.png';
import master_icon from 'assets/master_icon.png';
import React, { useContext } from 'react';
import Button from 'components/Styled/Button/Button';
import RoomProvider from 'components/Provider/RoomProvider';
import SocketProvider from 'components/Provider/SocketProvider';
import { stylizeKeyword } from 'others/keywords/keywordstyles';
import { GridList, GridListTile } from '@material-ui/core';

function PlayerItem({player, isRoomMaster, index}) {
    const { room } = useContext(RoomProvider);
    const { socket } = useContext(SocketProvider);

    const roleName = player.role?.name; 

    var backColor = room.playingPlayerIndex == index ? 'rgb(255, 145, 0)' : 'white';
    backColor = index == room.godFatherIndex ? '#ff4040' : backColor;

    const overlayClass = ((player.win == false && player.revealed) || !player.connected )&& 'pa_loose';

    var isGodFather = room.localPlayer?.role?.name == 'GodFather';

    const jokerImgs = [];
    if(roleName == 'GodFather'){
        for (let i = 0; i < player.joker; i++) {
            jokerImgs.push(
                <GridListTile key={`joker ${i}`} cols={1}>
                    <img src={joker} alt='joker' title='Joker' className='pa_joker' />
                </GridListTile>
            );
        }
    }

    const emptyYourPockets = () => {
        if(isGodFather && room.status == 'Debate'){
            const data = {
                susPlayer: player,
                roomName: room.name
            };
            socket.emit('emptyYourPockets', data);
        }
    }

    return (
        <div style={{ position: 'relative' }}>
            <div className={`pa_itemContainer ${overlayClass}`} style={{backgroundColor: backColor}}>
                <img src={avatar} alt='Avatar' className='avatar' />
                <p className="pa_itemName">{player.name}</p>
                {
                    isGodFather && player.role?.name != 'GodFather' && room.status == 'Debate' && !player.designated &&
                    <Button 
                        id='btn_emptyYourPockets' 
                        onClick={emptyYourPockets}
                    >
                        Vide tes poches !
                    </Button>
                }

                {
                    isRoomMaster &&
                    <img id='pa_masterIcon' src={master_icon} alt='room master' />
                }
            </div>
            {
                (player.revealed) && player.revealed &&
                <p className="pa_revealRole" dangerouslySetInnerHTML={{
                    __html: stylizeKeyword(`[${roleName}]`) + ` (${player.diamondCount})` 
                }} />
            }
            {
                jokerImgs.length > 0 && 
                <GridList id='pa_jokersContainer' cols={2} cellHeight={34}>
                    { jokerImgs }
                </GridList>
            }
        </div>
    );
}

export default PlayerItem;